import { computed, ref, watch } from "vue";
import { useStore } from "vuex";

export default function useSections() {
  const store = useStore();
  const course = ref();
  const openSectionsModal = ref(false);
  const file = ref({ file: "", filename: "" });

  const error = computed(() => store.getters["utilities/getErrors"]);
  const loading = computed(() => store.getters["utilities/isLoading"]);
  const loadingSections = computed(
    () => store.getters["utilities/isLoadingSections"]
  );
  const success = computed(() => store.getters["utilities/getSuccessStatus"]);

  watch(error, (newError) => {
    if (newError) {
      store.dispatch("toastNotification/displayToast", {
        message: newError,
        type: "error",
      });
    }
  });

  watch(success, (newStatus) => {
    if (newStatus) {
      store.dispatch("toastNotification/displayToast", {
        message: "Course configuration updated successfully.",
        type: "success",
      });
    }
  });

  const isFormValid = computed(() => {
    return file.value.file && course.value?.id;
  });

  const uploadSections = () => {
    const payload = new FormData();
    payload.append("file", file.value.file);
    store.dispatch("utilities/uploadSections", {
      payload,
      courseId: course.value?.id,
    });
  };

  const openSectionsTableModal = async () => {
    openSectionsModal.value = true;
    await store.dispatch("utilities/fetchSections", course.value?.id);
  };

  return {
    course,
    file,
    loading,
    loadingSections,
    isFormValid,
    uploadSections,
    openSectionsModal,
    openSectionsTableModal,
  };
}
